import { useQuery } from "@tanstack/react-query";
import {
  fetchColaboradores,
  fetchConfiguracionGlobal,
  fetchEdicion,
  fetchEventoBySlug,
  fetchEventos,
  fetchEventosProximos,
  fetchGaleriaBySlug,
  fetchGalerias,
  fetchNoticiaBySlug,
  fetchNoticias,
  fetchNoticiasDestacadas,
  fetchPaginaEstatica,
  fetchPaginaInicio,
  fetchPaginaProyecto,
  fetchPersonas,
  fetchProgramaBySlug,
  fetchProgramas,
  fetchSedes,
} from "../lib/strapi";

export function useProgramas() {
  return useQuery({
    queryKey: ["programas"],
    queryFn: async () => (await fetchProgramas()).data,
  });
}

export function useProgramaBySlug(slug: string) {
  return useQuery({
    queryKey: ["programa", slug],
    queryFn: async () => (await fetchProgramaBySlug(slug)).data?.[0] ?? null,
    enabled: Boolean(slug),
  });
}

export function useEdicion(slug: string) {
  return useQuery({
    queryKey: ["edicion", slug],
    queryFn: async () => (await fetchEdicion(slug)).data?.[0] ?? null,
    enabled: Boolean(slug),
  });
}

export function useSedes() {
  return useQuery({
    queryKey: ["sedes"],
    queryFn: async () => (await fetchSedes()).data,
  });
}

export function usePersonas(equipoEstable?: boolean) {
  return useQuery({
    queryKey: ["personas", { equipoEstable }],
    queryFn: async () => (await fetchPersonas({ equipoEstable })).data,
  });
}

export function useGalerias(limit = 12) {
  return useQuery({
    queryKey: ["galerias", limit],
    queryFn: async () => (await fetchGalerias(limit)).data,
  });
}

export function useGaleria(slug: string) {
  return useQuery({
    queryKey: ["galeria", slug],
    queryFn: async () => (await fetchGaleriaBySlug(slug)).data?.[0] ?? null,
    enabled: Boolean(slug),
  });
}

export function useNoticias(limit = 12) {
  return useQuery({
    queryKey: ["noticias", limit],
    queryFn: async () => (await fetchNoticias(limit)).data,
  });
}

export function useNoticiasDestacadas(limit = 3) {
  return useQuery({
    queryKey: ["noticias-destacadas", limit],
    queryFn: async () => (await fetchNoticiasDestacadas(limit)).data,
  });
}

export function useNoticia(slug: string) {
  return useQuery({
    queryKey: ["noticia", slug],
    queryFn: async () => (await fetchNoticiaBySlug(slug)).data?.[0] ?? null,
    enabled: Boolean(slug),
  });
}

export function useEventosProximos(limit = 6) {
  return useQuery({
    queryKey: ["eventos-proximos", limit],
    queryFn: async () => (await fetchEventosProximos(limit)).data,
  });
}

export function useEventos(limit = 48) {
  return useQuery({
    queryKey: ["eventos", limit],
    queryFn: async () => (await fetchEventos(limit)).data,
  });
}

export function useEvento(slug: string) {
  return useQuery({
    queryKey: ["evento", slug],
    queryFn: async () => (await fetchEventoBySlug(slug)).data?.[0] ?? null,
    enabled: Boolean(slug),
  });
}

export function usePaginaEstatica(slug: string) {
  return useQuery({
    queryKey: ["pagina-estatica", slug],
    queryFn: async () => (await fetchPaginaEstatica(slug)).data?.[0] ?? null,
    enabled: Boolean(slug),
  });
}

export function useColaboradores() {
  return useQuery({
    queryKey: ["colaboradores"],
    queryFn: async () => (await fetchColaboradores()).data,
  });
}

export function useConfiguracionGlobal() {
  return useQuery({
    queryKey: ["configuracion-global"],
    queryFn: async () => (await fetchConfiguracionGlobal()).data,
  });
}

export function usePaginaProyecto() {
  return useQuery({
    queryKey: ["pagina-proyecto"],
    queryFn: async () => (await fetchPaginaProyecto()).data,
  });
}

export function usePaginaInicio() {
  return useQuery({
    queryKey: ["pagina-inicio"],
    queryFn: async () => (await fetchPaginaInicio()).data,
  });
}
